import React, { useRef, useState } from "react";
import GradeSettingContents, {
  type GradeSettingContentsHandle,
} from "./GradeSettingContents";
import useGradeConfig from "@hooks/useGradeConfig";
import useNurses from "@hooks/useNurses";
import { useShiftsQuery } from "@/hooks/roster-craete/useShiftsQuery";
import { useIsAdmin } from "@hooks/useAuth";
import CustomModal from "@/components/modal/CustomModal";

interface GradeSettingModalProps {
  onClose: () => void;
  selectedGroupId?: string | null;
  isAdmin: boolean;
}

const GradeSettingModal: React.FC<GradeSettingModalProps> = ({
  onClose,
  selectedGroupId,
}) => {
  const isAdmin = useIsAdmin();
  const gid = isAdmin ? (selectedGroupId ?? "") : "";

  const contentsRef = useRef<GradeSettingContentsHandle>(null);
  const [savePending, setSavePending] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [isExitConfirmOpen, setIsExitConfirmOpen] = useState(false);

  const { isLoading: isShiftsLoading } = useShiftsQuery(gid);
  const { isLoading } = useGradeConfig({ selectedGroupId: gid });
  const { isLoading: nurseLoading } = useNurses(gid);

  const requestClose = () => {
    if (savePending) return;
    if (!isDirty) {
      onClose();
      return;
    }
    setIsExitConfirmOpen(true);
  };

  const closeWithoutSave = () => {
    setIsExitConfirmOpen(false);
    onClose();
  };

  const saveAndClose = () => {
    contentsRef.current?.triggerSaveDirect();
  };

  return (
    <>
      <CustomModal.Confirm
        isOpen={isExitConfirmOpen}
        onClose={closeWithoutSave}
        onConfirm={saveAndClose}
        isPending={savePending}
        pendingMsg="저장 중입니다..."
        title="변경사항을 저장하시겠습니까?"
        confirmText="저장"
        cancelText="취소"
      />
      <CustomModal.Panel
        onClose={requestClose}
        isLoading={isLoading || isShiftsLoading || nurseLoading}
        button
        btnCancelText="닫기"
        btnSuccessText="저장"
        btnCancelOnClick={requestClose}
        btnSuccessOnClick={() => contentsRef.current?.triggerSave()}
        btnSuccessDisabled={savePending}
      >
        <GradeSettingContents
          ref={contentsRef}
          onClose={onClose}
          selectedGroupId={gid}
          onMutationPendingChange={setSavePending}
          onDirtyChange={setIsDirty}
        />
      </CustomModal.Panel>
    </>
  );
};

export default GradeSettingModal;
